import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Image } from '@thd-olt-component-react/image';
import './global.scss';
import './BoxHero.scss';

const BoxHero = (props) => {
  const { opts = {}, channel } = props;
  const {
    id,
    ctaLink,
    heroMedia = {},
    heroMediaMobile = {},
    backgroundMedia = {},
    eventLogo = {},
    eventLogoMobile = {},
    heading = '',
    cta,
    collectionLink,
    cornerCaption,
    subHeading
  } = opts;
  const isMobile = channel === 'mobile';
  const backgroundStyle = backgroundMedia.src
    ? {
      'background-image': `'url(${backgroundMedia.src})';
      'background-repeat':'no-repeat';
      'background-size':'100% 100%;'`
    }
    : {
      'background-color': '#eeeeee;'
    };

  const renderHeroMedia = () => {
    const media = isMobile ? heroMediaMobile : heroMedia;
    const { src, alt, height, width } = media;
    const imgClass = classNames({
      'img--block':height && width
    });
    return (
      <picture className="EtchBoxHero__media">
        <source media="(min-width: 640px)" srcSet={src} />
        <Image src={src} className={imgClass} alt={alt} height={height} width={width} />
      </picture>
    )
  }

  const renderEventLogo = () => {
    const logo = isMobile ? eventLogoMobile : eventLogo;
    const { src, alt, height, width } = logo;
    const imgClass = classNames({
      'img--block':height && width
    });
    return (
      <picture>
        <source media="(max-width: 640px)" srcSet={src} />
        <Image src={src} className={`EtchBoxHero__body__eventLogo ${imgClass}`} alt={alt} height={height} width={width} />
      </picture>
    )
  }

  return (
    <div className="EtchBoxHero etch-analytics" data-module-id={id} style={backgroundStyle}>
      {ctaLink && (
        <a className="EtchBoxHero__link" href={ctaLink}>
          {renderHeroMedia()}
        </a>
      )}
      <div className="EtchBoxHero__body u__text-shadow--none">
        {renderEventLogo()}
        <p className="EtchBoxHero__body__heading u__xlarge u__display-font--black">
          {ctaLink ? (
            <a className="EtchBoxHero__link" href={ctaLink}>
              {heading}
            </a>
          ) : heading}
        </p>
        <p className="EtchBoxHero__body__subHeading u__medium">
          {ctaLink ? <a className="EtchBoxHero__link" href={ctaLink}>{subHeading}</a> : subHeading}
        </p>
        {cta && (
          <a className="EtchBoxHero__btn bttn bttn--primary bttn--inline" href={ctaLink}>
            <span className="EtchBoxHero__btn__content bttn__content">{cta}</span>
          </a>
        )}
      </div>
      <div className="EtchBoxHero__corner">
        {
          collectionLink ? (
            <a
              className="EtchBoxHero__corner__caption"
              href={collectionLink}
            >{cornerCaption}
            </a>
          ) : <p className="EtchBoxHero__corner__caption">{cornerCaption}</p>
        }
      </div>
    </div>
  );
};

BoxHero.propTypes = {
  // eslint-disable-next-line react/require-default-props
  opts: PropTypes.shape({
    id: PropTypes.string,
    ctaLink: PropTypes.string,
    heroMedia: PropTypes.object,
    heroMediaMobile: PropTypes.object,
    eventLogo: PropTypes.object,
    eventLogoMobile: PropTypes.object,
    heading: PropTypes.string,
    subHeading: PropTypes.string,
    cta: PropTypes.string,
    collectionLink: PropTypes.string,
    cornerCaption: PropTypes.string,
    type: PropTypes.string
  }),
  channel: PropTypes.string
};

BoxHero.defaultProps = {
  channel: 'mobile'
};

export default BoxHero;
